import React from 'react';

const BizCentral = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 70 70"
    className="logo-icon"
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M35 70c19.33 0 35-15.67 35-35S54.33 0 35 0 0 15.67 0 35s15.67 35 35 35zm0-5.185C18.534 64.815 5.185 51.466 5.185 35S18.534 5.185 35 5.185 64.815 18.534 64.815 35 51.466 64.815 35 64.815z"
      />
      <g transform="translate(15.556 19.444)">
        <rect
          width="38.889"
          height="25.926"
          y="6.481"
          fill="#FFF"
          opacity=".803"
          rx="2"
        />
        <path
          fill="#003B66"
          d="M1.576 7.591l9.094 6.406a15.966 15.966 0 0 0 18.906-.38l7.705-5.903a1 1 0 0 1 1.608.794v21.9a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8.408a1 1 0 0 1 1.576-.818z"
        />
        <path
          fill="#FFF"
          d="M1.64 7.845l8.966 7.458a14.477 14.477 0 0 0 18.97-.396l7.642-6.914a1 1 0 0 1 1.67.742v21.672a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8.614a1 1 0 0 1 1.64-.769zM23.333 0a2.61 2.61 0 0 1 1.248.32 2.586 2.586 0 0 1 1.025 1.023 2.586 2.586 0 0 1 .272.753l.003.013c.03.157.045.318.045.484v2.592h-2.593V2.592h-7.778v2.593h-2.592V2.593A2.593 2.593 0 0 1 15.392.005L15.556 0h7.777z"
        />
        <rect
          width="7.778"
          height="2.593"
          x="16.204"
          y="20.741"
          fill="#108EE9"
          rx="1.296"
        />
      </g>
    </g>
  </svg>
);

export default BizCentral;
